// eslint-disable-next-line
export const SENTRY_DSN_TOKEN: string = import.meta.env.SENTRY_DSN_TOKEN;
